import React from 'react';
import ReadPurchaseData from './Read';
import WritePurchaseData from './Write';

export default function PurchaseData(props) {
  const { isUpdate, inputChange, dataProduct } = props; //data Products

  return isUpdate ? (
    <WritePurchaseData inputChange={inputChange} dataProduct={dataProduct} />
  ) : (
    <ReadPurchaseData dataProduct={dataProduct} />
  );
}
